import actionBar from "../components/action-bar";
import buildingOnload from '../components/building-on-load';
import buildingMap from '../components/building-map';
import gallery from '../components/gallery';
import sidebar from '../components/sidebar';
import productTypeTabs from '../components/product-type-tabs';
import formPopUp from '../components/form-popup';
import amenitiesAccordion from '../components/amenities-accordion';

export default () => {
    productTypeTabs();
    buildingOnload();
    buildingMap();
    sidebar();
    gallery();
    actionBar();
    formPopUp();
    amenitiesAccordion();
}